import styled from '@emotion/styled';

interface CardboxProps {
  width?: string;
  isDesktopStyle?: boolean;
}

const Cardbox = styled.div<CardboxProps>`
  background: var(--white);
  box-shadow: 0px 4px 20px 0px #0000001a;
  width: ${props => props.width ?? '480px'};
  border-radius: ${({ isDesktopStyle = true }) => (isDesktopStyle ? '24px' : '0')};
  padding: 24px;
  max-width: 100%;
  overflow-x: hidden;

  @media only screen and (min-width: 900px) {
    padding: 40px;
  }

  span {
    line-height: normal;
  }
`;

export default Cardbox;
